import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./AdminOperations.css";
import { getClases, routeCreateLink } from "./constants";

export const ZoomLink = () => {
  const [matriculaClase, setMatriculaClase] = useState("");
  const [url, setUrl] = useState("");
  const [fecha, setFecha] = useState("");
  const [hora, setHora] = useState("");
  const [clases, setClases] = useState([]);
  const [cargandoClases, setCargandoClases] = useState(true);
  const [estaGuardando, setEstaGuardando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const peticionEnProceso = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    const cargarClases = async () => {
      try {
        const response = await axios.get(getClases);
        const lista = response.data?.data ?? response.data ?? [];
        setClases(Array.isArray(lista) ? lista : []);
      } catch (error) {
        console.error("Error al cargar clases:", error);
        setResultado({
          tipo: "error",
          mensaje: "No fue posible cargar las clases disponibles.",
        });
      } finally {
        setCargandoClases(false);
      }
    };

    cargarClases();
  }, []);

  const handleSubmitLink = async (event) => {
    event.preventDefault();

    if (peticionEnProceso.current) {
      return;
    }

    const claseSeleccionada = clases.find(
      (clase) =>
        `${clase.matricula_clase} - ${clase.nombre_clase}` === matriculaClase,
    );

    if (!claseSeleccionada) {
      setResultado({
        tipo: "warning",
        mensaje: "Selecciona una clase válida de la lista.",
      });
      return;
    }

    peticionEnProceso.current = true;
    setEstaGuardando(true);
    setResultado(null);

    try {
      const response = await axios.post(routeCreateLink, {
        url,
        matricula_clase: claseSeleccionada.matricula_clase,
        fecha,
        hora,
      });

      setResultado({
        tipo: "success",
        mensaje:
          response.data?.message || "La reunión de Zoom se creó correctamente.",
      });
      setUrl("");
      setFecha("");
      setHora("");
    } catch (error) {
      console.error("Error al crear link", error);
      setResultado({
        tipo: "error",
        mensaje:
          error.response?.data?.message ||
          error.response?.data?.error ||
          "No fue posible crear la reunión. Inténtalo de nuevo.",
      });
    } finally {
      peticionEnProceso.current = false;
      setEstaGuardando(false);
    }
  };

  return (
    <div className="admin-operation-page">
      <main className="admin-operation-container admin-operation-container-narrow">
        <header className="admin-operation-header">
          <p className="admin-operation-eyebrow">Sesiones en línea</p>
          <h1>Agregar reunión de Zoom</h1>
          <p>
            Relaciona una liga de reunión con la clase, fecha y hora en que
            estará disponible para los alumnos.
          </p>
        </header>

        <form className="admin-operation-panel" onSubmit={handleSubmitLink}>
          <div className="admin-operation-grid">
            <section className="admin-operation-card">
              <div className="admin-operation-card-heading">
                <span>1</span>
                <div>
                  <h2>Selecciona la clase</h2>
                  <p>Busca por matrícula o nombre de la materia.</p>
                </div>
              </div>
              <div className="admin-operation-field">
                <label htmlFor="zoom-link-class">Clase</label>
                <input
                  id="zoom-link-class"
                  type="text"
                  list="zoom-link-classes"
                  value={matriculaClase}
                  onChange={(event) => setMatriculaClase(event.target.value)}
                  placeholder={
                    cargandoClases
                      ? "Cargando clases..."
                      : "Escribe para buscar una clase"
                  }
                  disabled={cargandoClases || estaGuardando}
                  autoComplete="off"
                  required
                />
                <datalist id="zoom-link-classes">
                  {clases.map((clase) => (
                    <option
                      key={clase.id_clase ?? clase.matricula_clase}
                      value={`${clase.matricula_clase} - ${clase.nombre_clase}`}
                    />
                  ))}
                </datalist>
              </div>
            </section>

            <section className="admin-operation-card">
              <div className="admin-operation-card-heading">
                <span>2</span>
                <div>
                  <h2>Configura la reunión</h2>
                  <p>Agrega la liga y el horario programado.</p>
                </div>
              </div>
              <div className="admin-operation-field">
                <label htmlFor="zoom-link-url">URL de Zoom</label>
                <input
                  id="zoom-link-url"
                  type="url"
                  value={url}
                  onChange={(event) => setUrl(event.target.value)}
                  placeholder="https://zoom.us/j/..."
                  disabled={estaGuardando}
                  required
                />
              </div>
              <div className="admin-operation-form-grid admin-operation-section-gap">
                <div className="admin-operation-field">
                  <label htmlFor="zoom-link-date">Fecha</label>
                  <input
                    id="zoom-link-date"
                    type="date"
                    value={fecha}
                    onChange={(event) => setFecha(event.target.value)}
                    disabled={estaGuardando}
                    required
                  />
                </div>
                <div className="admin-operation-field">
                  <label htmlFor="zoom-link-time">Hora</label>
                  <input
                    id="zoom-link-time"
                    type="time"
                    value={hora}
                    onChange={(event) => setHora(event.target.value)}
                    disabled={estaGuardando}
                    required
                  />
                </div>
              </div>
            </section>
          </div>

          {resultado && (
            <div
              className={`admin-operation-status admin-operation-status-${resultado.tipo}`}
              role="status"
              aria-live="polite"
            >
              {resultado.mensaje}
            </div>
          )}

          <div className="admin-operation-actions">
            <button
              className="admin-operation-button"
              type="submit"
              disabled={cargandoClases || clases.length === 0 || estaGuardando}
            >
              {estaGuardando ? "Guardando reunión..." : "Agregar reunión"}
            </button>
            <button
              className="admin-operation-button admin-operation-button-secondary"
              type="button"
              onClick={() => navigate("/admin-home")}
              disabled={estaGuardando}
            >
              Regresar al inicio
            </button>
          </div>
        </form>
      </main>
    </div>
  );
};
